import { render, staticRenderFns } from "./goodsCategorySetting.vue?vue&type=template&id=79287d3e&scoped=true&"
import script from "./goodsCategorySetting.vue?vue&type=script&lang=js&"
export * from "./goodsCategorySetting.vue?vue&type=script&lang=js&"
import style0 from "./goodsCategorySetting.vue?vue&type=style&index=0&id=79287d3e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79287d3e",
  null
  
)

export default component.exports